export const MOBILE_APP_HEADER_NAMES = {
  AppVersion: 'X-App-Version',
  Platform: 'X-Platform',
} as const;

export const MOBILE_APP_WEB_HEADER_VALUES = {
  AppVersion: '1',
  Platform: 'Web',
} as const;

export const MOBILE_APP_WEB_HEADERS: Record<string, string> = {
  [MOBILE_APP_HEADER_NAMES.AppVersion]: MOBILE_APP_WEB_HEADER_VALUES.AppVersion,
  [MOBILE_APP_HEADER_NAMES.Platform]: MOBILE_APP_WEB_HEADER_VALUES.Platform,
};
